module.exports = __webpack_public_path__ + "static/media/Valk1.aeb13775.png";